import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useDebounce from './useDebounce';
import { fetchTimeline, fetchModel } from '../store/api';
import { gotApiError } from '../store/api/actions';

const getData = async (from, to) => {
  const { response: timeline, error: timelineError } = await fetchTimeline({
    from: from.toUTC(),
    to: to.toUTC(),
  });
  if (timelineError) {
    return { error: timelineError, title: 'Timeline fetch failed' };
  }
  const { response: model, error: modelError } = await fetchModel();
  if (modelError) {
    return { error: modelError, title: 'Model fetch failed' };
  }
  const mappedTimelineToModel = timeline.map((entry) => {
    const { id, observations } = entry;
    const modelObject = model[id];

    return {
      id,
      observations,
      label: modelObject.function.label,
      sensor: modelObject.sensor,
      limits: modelObject.limits,
      unit: modelObject.unit,
    };
  });
  return { data: mappedTimelineToModel };
};

const useTimeline = (from, to) => {
  const [abnormals, setAbnormals] = useState([]);
  const dispatch = useDispatch();

  const debouncedTo = useDebounce(to, 500);
  const debouncedFrom = useDebounce(from, 500);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    getData(debouncedTo, debouncedFrom)
      .then((result) => {
        if (result.error) {
          dispatch(gotApiError({ message: result.error, title: result.title }));
          setAbnormals([]);
        } else {
          setAbnormals(result.data ?? []);
        }
      })
      .finally(() => setLoading(false));
  }, [debouncedFrom, debouncedTo, dispatch]);

  return { abnormals, loading };
};

export default useTimeline;
